import React from 'react';
import { connect } from 'react-redux';
import { Helmet } from 'react-helmet';
import {
  setView,
  requestExportPatientAdvocate,
  requestPatientAdvocates
} from '../../../store/advocate-dashboard/AdvocateActions';

import AdvocateLayout from '../components/AdvocateLayout';
import { hostTitle } from '../../../config/ui';

class AdvocateDashboard extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showNotes: false,
      selectedNote: null,
    };
  }

  componentWillMount() {
    this.props.setView('ADVOCATES');
  }

  fetchNotes = (
    page = 0,
    perPage = 25,
    order = '',
    search = '',
    filters = '',
    params = {},
  ) => {
    return this.props.getPatientAdvocates({
      offset: page * perPage,
      limit: perPage,
      order,
      search,
      filters,
      ...params,
      ...this.props.currentUser.queryParams,
    });
  };

  fetchDownload = (
    page = 0,
    perPage = 25,
    order = '',
    search = '',
    filters = '',
    params = {},
  ) => {
    return this.props.downloadPatientAdvocate({
      offset: page * perPage,
      limit: perPage,
      order,
      search,
      filters,
      ...params,
      ...this.props.currentUser.queryParams,
    });
  };

  render() {
    const { data, isLoading, limits, lookups, ...otherProps } = this.props;
    return (
      <div>
        <Helmet title={`Advocates – ${hostTitle()}`} />
        <AdvocateLayout
          view="ADVOCATES"
          title="Advocates"
          fetchNotes={this.fetchNotes}
          fetchDownload={this.fetchDownload}
          data={data}
          isLoading={isLoading}
          {...otherProps}
        />
      </div>
    );
  }
}
export default connect(
  (state) => ({ ...state.advocates, currentUser: state.currentUser }),
  (dispatch) => ({
    getPatientAdvocates: (params) => dispatch(requestPatientAdvocates(params)),
    setView: (view) => dispatch(setView(view)),
    downloadPatientAdvocate: (params) => dispatch(requestExportPatientAdvocate(params)),
  }),
)(AdvocateDashboard);



// WEBPACK FOOTER //
// ./src/routes/management/containers/AdvocateDashboard.js